"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verticalPadding = exports.titleSpacing = exports.minHeight = void 0;
var verticalPadding = exports.verticalPadding = {
  sm: '4px' /* TODO: can we use an encore token here? */,
  md: '8px' /* TODO: can we use an encore token here? */,
  lg: '8px' /* TODO: can we use an encore token here? */,
  xl: '12px' /* TODO: can we use an encore token here? */,
  xxl: '12px' /* TODO: can we use an encore token here? */
};
var titleSpacing = exports.titleSpacing = {
  sm: '2px' /* TODO: can we use an encore token here? */,
  md: '2px' /* TODO: can we use an encore token here? */,
  lg: '2px' /* TODO: can we use an encore token here? */,
  xl: '4px' /* TODO: can we use an encore token here? */,
  xxl: '4px' /* TODO: can we use an encore token here? */
};
var minHeight = exports.minHeight = {
  sm: '32px' /* TODO: can we use an encore token here? */,
  md: '48px' /* TODO: can we use an encore token here? */,
  lg: '56px' /* TODO: can we use an encore token here? */,
  xl: '56px' /* TODO: can we use an encore token here? */,
  xxl: '56px' /* TODO: can we use an encore token here? */
};